export default __webpack_public_path__ + "static/media/icon-close.c3a90474.svg";